import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getPaymentQuote } from "../redux/actions/PaymentActions";

// Card payment offer of a request ({ fee, total }), or null when the card
// is not available. Read again when the amount to pay changes.
export default function useCardOffer(token, request, amount) {
  const dispatch = useDispatch();
  const [offer, setOffer] = useState(null);

  useEffect(() => {
    let active = true;

    setOffer(null);

    if (!token || !request) return undefined;

    dispatch(
      getPaymentQuote(token, request, (response) => {
        const card = response.success && response.data?.card;

        if (active && response.data?.payable && card?.available) {
          setOffer(card);
        }
      }),
    );

    return () => {
      active = false;
    };
  }, [dispatch, token, request, amount]);

  return offer;
}
